export const VALIDATIONS_REGEX = {
  allowOnlyNumber: /[^\d]/g,
  replaceMobilePhonePrefix: /^\+(57)|(5)/,
  replaceLandLinePrefix: /^(60)|(6)/,
};

export const PHONE_VALIDATIONS_LENGTH = {
  mobilePhoneWithPrefix: 12,
  landlineWithPrefix: 10,
};

export const MONTH_BY_NUMBER = {
  1: 'Enero',
  2: 'Febrero',
  3: 'Marzo',
  4: 'Abril',
  5: 'Mayo',
  6: 'Junio',
  7: 'Julio',
  8: 'Agosto',
  9: 'Septiembre',
  10: 'Octubre',
  11: 'Noviembre',
  12: 'Diciembre',
};

// ----------------------------------------------- ROLES -----------------------------------------------

export const ROLES = [
  'client',
  'admin',
  'analyst',
  'superadmin',
  'director',
  'commercial',
  'forwardercoordinator',
  'comprehensivelogisticscoordinator',
  'customscoordinator',
  'storagecoordinator',
  'internalanalyst',
];

export const ROLES_SPANISH = {
  client: 'Cliente',
  admin: 'Administrador',
  superadmin: 'Super Administrador',
  analyst: 'Analista',
  internalanalyst: 'Analista interno',
  director: 'Director',
  commercial: 'Comercial',
  forwardercoordinator: 'Coordinador Forwarder',
  comprehensivelogisticscoordinator: 'Coordinador Logística Integral',
  customscoordinator: 'Coordinador Aduanas',
  storagecoordinator: 'Coordinador Almacen',
  withoutrol: 'Sin Rol',
};

export const ROLES_TO_HIDE_LAYOUT = [
  'admin',
  'commercial',
  'superadmin',
  'forwardercoordinator',
  'comprehensivelogisticscoordinator',
  'customscoordinator',
  'storagecoordinator',
];

export const ROLES_CAN_SEE_CLIENTS = ['analyst'];

export const ROLES_CAN_SEE_COLUMN_CLIENT = [
  'analyst',
  'admin',
  'superadmin',
  'director',
  'commercial',
  'forwardercoordinator',
  'comprehensivelogisticscoordinator',
  'customscoordinator',
  'storagecoordinator',
];

export const ROLES_CAN_ADD_COMMENTS = ['analyst', 'internalanalyst'];

export const ROLES_CAN_UPDATE_OPERATION = ['analyst'];

export const ROLES_CAN_UPDATE_ACTIVITY = ['analyst'];

export const ROLES_CAN_MANAGE_COMPANIES = [
  'forwardercoordinator',
  'comprehensivelogisticscoordinator',
  'customscoordinator',
  'storagecoordinator',
];

export const ROLES_CAN_MANAGE_ANALYSTS = ['superadmin', 'admin'];

export const ROLES_CAN_SEE_REPORTS = ['superadmin', 'admin', 'internalanalyst', 'director', 'commercial', 'forwardercoordinator', 'comprehensivelogisticscoordinator', 'customscoordinator', 'storagecoordinator'];

export const ROLES_CAN_CREATE_CLIENTS = [
  'superadmin',
  'admin',
  'commercial',
  'forwardercoordinator',
  'comprehensivelogisticscoordinator',
  'customscoordinator',
  'storagecoordinator',
];

export const ROLES_CAN_CREATE_COMPANIES = [
  'commercial',
  'forwardercoordinator',
  'comprehensivelogisticscoordinator',
  'customscoordinator',
  'storagecoordinator',
];

export const ROLES_CAN_CHANGE_RESPONSABLE = [
  'forwardercoordinator',
  'comprehensivelogisticscoordinator',
  'customscoordinator',
  'storagecoordinator',
];

export const activitiesWithContainer = [
  'En Proceso De Asignacion De Vehiculo Y Cita',
  'Vehiculo Y Cita Asignada',
  'Sello Satelital Solicitado',
  'Acompañamiento Vehicular Motorizado',
  'Vehiculo En Transito',
  'Llegada A Deposito',
  'Vehiculo Descargado',
  'En Entrega Unidad Vacia',
  'Unidad Vacia Entregada',
  'Devolucion De La Unidad Vacia',
];
export const loginMessages = {
  sendEmailCode: 'Se envio el código con exito, revisa tu correo electrónico.',
  errorCode: '¡Error al enviar el código o cambiar contraseña!',
  errorValidateCode: '¡Código invalido!',
  errorCodeMaxAttempts: '¡Supero el limite de intentos!',
  NotAuthorizedException: '¡Usuario o contraseña incorrectos!',
  UserNotFoundException: '¡Usuario o contraseña incorrectos!',
  newPasswordRequired: 'Es necesario que cambies la contraseña',
  sessesfullyNewPassword: 'Contraseña actualizada correctamente',
  UserNotConfirmedException:
    'Es necesario terminar el registro, se envio un código a tu correo electrónico',
  UserDisabledException: 'Tu cuenta está deshabilitada',  
};

export const registerMessages = {
  sendEmailCode: 'Se envio el código con exito, revisa tu correo electrónico',
  errorCode: '¡Error al enviar el código o cambiar contraseña!',
  errorValidateCode: '¡Código invalido!',
  errorCodeMaxAttempts: '¡Supero el limite de intentos!',
  usernameExistsException: '¡El usuario ya se encuentra registrado!',
  successRegister: 'Registro exitoso ya puedes iniciar sesión',
  successAddRegister: 'Registro exitoso, se envío una contraseña temporal al correo del usuario',
  notFound: 'No se encontró el número de documento en la base de datos',
};

export const RPMessages = {
  sendEmailCode: 'Se envio el código con exito, revisa tu correo electrónico',
  errorCode: '¡Error al enviar el código o cambiar contraseña!',
  errorValidateCode: '¡Código invalido!',
  LimitExceededException: 'Supero el limite de intentos, porfavor inténtelo más tarde',
  NotAuthorizedException: '¡Usuario o contraseña incorrectos!',
  UserNotFoundException: '¡Usuario o contraseña incorrectos!',
  recoverPasswordSusses: 'Ya puedes iniciar sesión con tu nueva contrase',
  CodeMismatchException: 'Se proporcionó un código de verificación no válido. Inténtelo de nuevo',
  InvalidParameterException:
    'Los datos ingresados no son válidos. Por favor verifica la información.',
};
